import { Box, Collapse, IconButton, Typography } from '@mui/material';
import { ExpandMore, ChevronRight } from '@mui/icons-material';
import React from 'react';

interface ExpandableItemProps {
  title: string;
  totalText?: string;
  isOpen: boolean;
  onToggle: () => void;
  children: React.ReactNode;
  sx?: Record<string, unknown>;
}

const ExpandableItem = ({
  title,
  totalText,
  isOpen,
  onToggle,
  children,
  sx = {},
}: ExpandableItemProps) => {
  return (
    <Box sx={{ backgroundColor: '#f9f9f9', mb: 1, borderRadius: 1, ...sx }}>
      <Box
        onClick={onToggle}
        display="flex"
        justifyContent="space-between"
        alignItems="center"
        sx={{
          cursor: 'pointer',
          p: 1,
          borderRadius: 1,
          backgroundColor: '#e6f2ff',
        }}
      >
        <Box display="flex" alignItems="center">
          <IconButton size="small">
            {isOpen ? <ExpandMore /> : <ChevronRight />}
          </IconButton>
          <Typography fontSize="13px" className="expandable-title">
            {title}
          </Typography>
        </Box>
        {totalText && (
          <Typography fontSize="13px" className="expandable-title">{totalText}</Typography>
        )}
      </Box>

      <Collapse in={isOpen} timeout="auto" unmountOnExit>
        <Box sx={{ mt: 2, ml: 5, color: 'gray' }}>{children}</Box>
      </Collapse>
    </Box>
  );
};

export default ExpandableItem;
